import React from "react";
import TabTemplate from "../../../_shoru_shared_library/template/TabTemplate";
import auditionsRouter from "./auditionsRouter";

function AuditionsTab(props) {

  return (
    <TabTemplate 
      router={auditionsRouter}
      passData={props.passData}
    />
  )

}

export default AuditionsTab;